/**
 * Настройка Sentry для мониторинга ошибок и performance.
 * Performance-сбор (traces, replay) включается только при согласии «Performance cookies».
 */

import * as Sentry from '@sentry/react'
import { getPrivacyPreferences } from './privacyPreferences'

const dsn = import.meta.env.VITE_SENTRY_DSN

if (dsn) {
  const prefs = getPrivacyPreferences()
  const performanceAllowed = prefs.performance === true

  Sentry.init({
    dsn,
    sendDefaultPii: true, // IP и базовая информация для контекста ошибок
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    tracesSampleRate: performanceAllowed ? 1.0 : 0,
    replaysSessionSampleRate: performanceAllowed ? 0.1 : 0,
    replaysOnErrorSampleRate: performanceAllowed ? 1.0 : 0,
    environment: import.meta.env.MODE || 'development',
    beforeSend(event, hint) {
      return event
    }
  })

  console.log('✅ Sentry initialized', performanceAllowed ? '(performance on)' : '(performance off by privacy)')
} else {
  console.warn('⚠️ Sentry DSN not found, skipping initialization')
}

export default Sentry
